export interface OAuthLoginParams {
  client_id: string
  redirect_uri: string
  response_type: string
  state: string
  code_challenge?: string
  code_challenge_method?: string
  scope?: string
  [key: string]: string | undefined
}

const requiredOauthLoginParamKeys = ["client_id", "redirect_uri", "response_type", "state"] as const

export const buildOauthLoginParams = (params: URLSearchParams): OAuthLoginParams | null => {
  const nextParams = Object.fromEntries(params.entries()) as Record<string, string | undefined>

  const hasAllRequiredParams = requiredOauthLoginParamKeys.every(key => nextParams[key])

  if (!hasAllRequiredParams) {
    return null
  }

  return {
    client_id: nextParams.client_id as string,
    redirect_uri: nextParams.redirect_uri as string,
    response_type: nextParams.response_type as string,
    state: nextParams.state as string,
    code_challenge: nextParams.code_challenge,
    code_challenge_method: nextParams.code_challenge_method,
    scope: nextParams.scope,
  }
}
